import { admissionsFTs } from "./admissionsFTs";
import { admissionsAdminFTs } from "./admissionsAdminFTs";
import { recruitmentAdminFTs } from "./recruitmentAdminFTs";
import { recruitmentFTs } from "./recruitmentFTs";
import { landingpageFTs } from "./landingpageFTs";

export const FTs = { ...admissionsAdminFTs, ...admissionsFTs, ...recruitmentAdminFTs, ...recruitmentFTs, ...landingpageFTs };
